/**
 * Publishes a custom event with an optional payload.
 *
 * @template T - The type of the event name, extending `passiveTrackEvents`.
 * @param {T} eventName - The name of the event to publish.
 * @param {passiveTrackEventsDefinition[T]} [payload] - Optional payload to include with the event.
 * @returns {void}
 */
export function publish(eventName, payload) {
    const event = (payload !== undefined) ? new CustomEvent(eventName, { detail: payload }) : new CustomEvent(eventName);
    window.dispatchEvent(event);
}
/**
 * Subscribes to a custom event and registers a handler function to be called when the event is dispatched.
 *
 * @template T - The type of the event name, extending `passiveTrackEvents`.
 * @param {T} eventName - The name of the event to subscribe to.
 * @param {(payload: passiveTrackEventsDefinition[T]) => void} handlerFn - The handler function to be called when the event is dispatched.
 * @returns {unsubscribe} - A function to unsubscribe from the event.
 */
export function subscribe(eventName, handlerFn) {
    const eventHandler = (event) => {
        const eventPayload = event.detail;
        handlerFn(eventPayload);
    };
    window.addEventListener(eventName, eventHandler);
    return () => {
        window.removeEventListener(eventName, eventHandler);
    };
}



//////////////////
// WEBPACK FOOTER
// ./~/@celine/passive-tracking/dist/publish-subscribe.js
// module id = ./node_modules/@celine/passive-tracking/dist/publish-subscribe.js
// module chunks = 0